import {Type} from '@angular/core';

import {BaseFilter} from './base/base.filter';

export class AddressFilter extends BaseFilter {

    public street: string;

    public status: string;

    public constructor() {
        super();
    }

    protected getType(): Type<BaseFilter> {
        return AddressFilter;
    }
}
